import axios from "axios";
import { API_CONFIG } from "../pages/config";
import { useMockApi, mockPost } from "./mockApi";

const api = useMockApi
  ? {
      post: async (url, data) => {
        const res = await mockPost(url, data);
        if (res.status >= 200 && res.status < 300) {
          return { data: res.data };
        }
        const err = new Error("Mock API request failed");
        err.response = { status: res.status, data: res.data };
        throw err;
      },
    }
  : axios.create({
      baseURL: API_CONFIG.baseUrl,
      headers: {
        "Ocp-Apim-Subscription-Key": API_CONFIG.apiKey,
        "Content-Type": "application/json",
      },
    });

export default api;
